import React from 'react';
import {Regular, H2} from '@worthy-npm/clarity'
import {imageUrl} from 'helpers/ApplicationHelper';

const SectionH2P = (props) => {
    const {data} = props
    return (
        <div className={`section-H2P d-flex ${data.reverse? 'reverse-row-flex': ''}`}>
            <div className='content-container d-flex flex-col'>
                <div className='number-container'>
                <H2 bold={true} text={data.number}
                    overrideCSS={{ fontFamily: 'Roboto', fontSize: '40px', lineHeight: '50px'}}/>
                </div>
                <H2 bold={true} text={data.sectionTitle}
                    overrideCSS={{ fontFamily: 'Roboto', fontSize: '40px', lineHeight: '50px', margin: '12px 0'}}/>
                <Regular text={data.sectionText}/>
            </div>
            <div className='image-container d-flex'>
                <img className='DT-pic' alt='bar-icon' src={imageUrl(data.sectionPic)}/>
                <img className='MB-pic' alt='bar-icon' src={imageUrl(data.sectionPicMobile)}/>
            </div>
        </div>
    );
}

export default SectionH2P;